/**
 * isiXhosa: Files
 *
 * What this file covers: Uploading files and previewing them (documents, images, audio, video).
 *
 * Tone: Short functional labels, like a file manager.
 *
 * isiXhosa: Everyday isiXhosa as used in South African business. Keys not translated yet fall back to English,
 * so a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const files: Catalog = {
  'upload.prompt': 'Yisa ifayile apha, okanye ucofe ukuze ukhangele',
  'upload.library': 'Khetha kwithala',
  'upload.library.title': 'Ithala leemidiya',
  'upload.library.search': 'Khangela ngegama lefayile',
  'upload.library.empty': 'Akukho nto okwangoku. Layisha ifayile ukuze uyibone apha.',
  'upload.library.more': 'Layisha okungakumbi',
  'upload.uploading': 'Iyalayisha',
  'upload.replace': 'Tshintsha',
  'upload.rename': 'Nika igama elitsha',
  'upload.rename.title': 'Nika ifayile igama elitsha',
  'upload.rename.placeholder': 'Igama lefayile',
  'upload.copy': 'Khuphela ikhonkco',
  'upload.copied': 'Kukhutshelwe',
  'upload.select': 'Khetha',
  'upload.delete': 'Cima ngonaphakade',
  'upload.delete.confirm': 'Cima le fayile kubo bonke? Nantoni na esayisebenzisayo iya kwaphuka.',
  'upload.filter.all': 'Konke',
  'upload.filter.image': 'Imifanekiso',
  'upload.filter.video': 'Ividiyo',
  'upload.filter.document': 'Amaxwebhu',
  'upload.error.tooLarge': 'Loo fayile inkulu kakhulu.',
  'upload.error.type': 'Olo hlobo lwefayile alwamkelwa.',
  'upload.error.infected': 'Loo fayile ayiphumelelanga ukuskenwa kwentsholongwane kwaye ayigcinwanga.',
  'upload.error.scanUnavailable': 'Isikena sentsholongwane asifikeleleki. Zama kwakhona kungekudala.',
  'upload.error.notConfigured': 'Ugcino lweefayile alusetelwanga. Umqhubi kufuneka alusete phantsi kweSeto, Udibaniso.',
  'upload.error.generic': 'Ukulayisha akuphumelelanga.'
};

export default files;
